import React, { useEffect, useState } from 'react';
import {
  getSingleSurvey,
  surveyResultPreview,
  getSurveyFormList,
  addFormContent,
  updateFormContent,
  getFormContent,
  imageUpload,
  markAsComplete,
  getAdminEmails,
} from '../../../api/services/services';
import backArrow from '../../../imgs/BackArrow.svg';
import MainTemplate from '../../templates/MainTemplate';
import { useNavigate } from 'react-router-dom';
import { Button, Snackbar } from '@mui/material';
import Typography from '@mui/material/Typography';
import MuiAlert from '@mui/material/Alert';
import { Bucket } from '../../../api/config/apiConfig';
import './style.css';
import ContactDetailField from '../../molecules/ContactDetailField';
import CustomCheckbox from '../../atoms/CustomCheckbox';
import DynamicText from '../../molecules/DynamicText';
import { useParams } from 'react-router-dom';

import upload from '../../../imgs/upload.png';

import LoadingModal from '../../molecules/LoadingModal';
import trashImg from '../../../imgs/trash.png';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import downloadIcon from '../../../imgs/download.png';
import PremiumCard from '../../molecules/PremiumCard';
import SectionHeader from '../../molecules/SectionHeader';
import DescriptionIcon from '@mui/icons-material/Description';
import ChecklistIcon from '@mui/icons-material/Checklist';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import EditIcon from '@mui/icons-material/Edit';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Grid, Tooltip, CircularProgress } from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DownloadIcon from '@mui/icons-material/Download';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

const MoveCheckList = () => {
  const { surveyId, info, flg } = useParams();

  const [surveyData, setSurveyData] = useState(null);
  const navigate = useNavigate();

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const [index, setIndex] = React.useState(-1);
  const [slides, setSlides] = useState([]);

  const [formContent, setFormContent] = useState({
    originAddress: '',
    destinationAddress: '',
    removalDate: '',
    createdDate: '',
    closingDate: '',
    arrangedBy: '',
    wayBillOfOriginAgent: [],
    wayBillOfBooker: [],
    oceanBillOfLoading: [],
    airWayBill: [],
    remarks: '',
    otherDocuments: [],
    refNo: {
      refPart1: '',
      refPart2: '',
    },
    clientName: '',
    shipmentMode: '',
  });

  const [formContentId, setFormContentId] = useState('');
  const [isEdit, setIsEdit] = useState(flg === '1' ? true : false);
  const [mediaKeysToSend, setMediaKeysToSend] = useState([]);
  const [mediaKeysToRemove, setMediaKeysToRemove] = useState([]);

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const [filesList, setFilesList] = useState([
    {
      name: 'Quotation Form',
      value: 'survey/quotation-form',
      id: 'be5690e1-df05-4791-a214-2235c757f0f3',
      isAdded: false,
    },
    {
      name: 'Crew Instruction Document',
      value: 'survey/crew-instruction-document',
      id: '3dcad948-1923-4a77-aecf-35c44f610753',
      isAdded: false,
    },
    {
      name: 'Packing Request Form',
      value: 'survey/packing-request-form',
      id: '795ed973-d542-45bb-b63d-f29f0c0f1693',
      isAdded: false,
    },
    {
      name: 'Packing Material Issued Sheet',
      value: 'survey/packing-material-issued-sheet',
      id: '178c68ff-0f74-471e-b64d-a5c0476a9380',
      isAdded: false,
    },
    {
      name: 'Worksheet',
      value: 'survey/worksheet-import',
      id: '5fb9aeb9-e1a3-4763-ada6-1eb83a8491b0',
      isAdded: false,
    },
    {
      name: 'Weight Ticket',
      value: 'survey/weight-ticket',
      id: 'e57266c3-322b-4a90-858b-806d2557e605',
      isAdded: false,
    },
    {
      name: 'Wooden Lift Van Quality Check Report',
      value: 'survey/wooden-lift-van-quality-check-report',
      id: '7ee33eb8-5471-47d3-837b-aeb0914bea73',
      isAdded: false,
    },
    {
      name: 'Shipping Instructions',
      value: 'survey/shipping-instructions',
      id: '3d6d82dd-e980-4fe9-bb5f-2b0877de9354',
      isAdded: false,
    },
    {
      name: 'Item Condition Report at Origin',
      value: 'survey/item-condition-report-at-origin',
      id: '19d7db4c-2bdd-492e-8b5f-5e030345fa47',
      isAdded: false,
    },
    {
      name: 'Delivery Receipt',
      value: 'survey/delivery-receipt',
      id: '0cc862ad-1e4b-4167-a50b-942747f35f57',
      isAdded: false,
    },
    {
      name: 'Delivery Request Form',
      value: 'survey/delivery-request-form',
      isAdded: false,
      id: 'a4a04109-6d40-4c84-9116-d82fbd27133a',
    },
    {
      name: 'Invoice',
      value: 'survey/invoice',
      id: '664aa0b2-661d-4311-a496-747c2b45ec87',
      isAdded: false,
    },

    {
      name: 'Load Unload Report',
      value: 'survey/load-unload-report',
      id: 'ba57ab91-9724-4614-af97-61705090fd37',
      isAdded: false,
    },
    {
      name: 'Packing Inventory',
      value: 'survey/packing-inventory',
      id: '1f81d381-5fdf-453f-ba00-e1ca03404eac',
      isAdded: false,
    },

    {
      name: 'Acknowledgement Receipt',
      value: 'survey/acknowledge-receipt',
      id: 'efa3d3dc-7681-4603-9871-f368ce0edde5',
      isAdded: false,
    },

    // {
    //   name: "Customer Feedback",
    //   value: "survey/customer-feed-back",
    //   id: "db4d50ca-bb10-4a97-9660-ee3c0cfa3470",
    //   isAdded: false,
    // },
  ]);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  //
  useEffect(() => {
    getSurveyFormList(surveyId)
      .then((res) => {
        let values = [...filesList];
        res?.data?.data?.map((fm, ind) => {
          filesList?.map((ls, index) => {
            if (fm?.form?.formId === ls?.id) {
              values[index].isAdded = true;
            }
          });
        });

        setFilesList(values);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = '/login';
        }
      });
  }, []);

  useEffect(() => {
    getContent();
    getAdminEmails()
      .then((res) => {
        setAdminEmails(res?.data?.data || []);
      })
      .catch((err) => {
        console.error("Failed to fetch admin emails", err);
      });
  }, []);

  const [adminEmails, setAdminEmails] = useState([]);
  const currentUser = JSON.parse(localStorage.getItem("shelUserData"));
  const currentUserEmail = currentUser?.email;
  const isAdmin = adminEmails.includes(currentUserEmail);

  //
  const convertDate = (unixTimestamp) => {
    const date = new Date(unixTimestamp * 1000); // Multiply by 1000 to convert from seconds to milliseconds
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so we add 1 and format with leading zero
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  //
  const getSurveyPreview = () => {
    surveyResultPreview(surveyId)
      .then((response) => {
        setSurveyData(response?.data?.data?.surveyDetail);
        let values = { ...formContent };
        values.originAddress = `${response?.data?.data?.surveyDetail?.loadPlaceStAddress}, ${response?.data?.data?.surveyDetail?.loadPlaceCity}, ${response?.data?.data?.surveyDetail?.loadPlaceCountry}`;
        values.destinationAddress = `${response?.data?.data?.surveyDetail?.unloadPlaceStAddress}, ${response?.data?.data?.surveyDetail?.unloadPlaceCity}, ${response?.data?.data?.surveyDetail?.unloadPlaceCountry}`;
        values.clientName = `${response?.data?.data?.surveyDetail?.name}`;
        values.clientEmail = `${response?.data?.data?.surveyDetail?.email}`;
        values.removalDate = `${convertDate(
          response?.data?.data?.surveyDetail?.loadDate,
        )}`;
        values.refNo = {
          refPart1: `${response?.data?.data?.surveyDetail?.id}`,
          refPart2: '',
        };
        values.status = 'submitted';

        setFormContent(values);
        setMediaKeysToSend([]);
        setMediaKeysToRemove([]);
      })
      .catch((error) => {
        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = '/login';
        }
        setMediaKeysToSend([]);
        setMediaKeysToRemove([]);
      });
  };

  const [infod, setInfo] = useState(info);
  //
  const getSurvey = () => {
    getSingleSurvey(surveyId)
      .then((response) => {
        if (response?.data?.data?.status === 'submitted') getSurveyPreview();
        else {
          setSurveyData(response?.data?.data);
          let values = { ...formContent };
          values.originAddress = `${response?.data?.data?.loadPlaceStAddress}, ${response?.data?.data?.loadPlaceCity}, ${response?.data?.data?.loadPlaceCountry}`;
          values.destinationAddress = `${response?.data?.data?.unloadPlaceStAddress}, ${response?.data?.data?.unloadPlaceCity}, ${response?.data?.data?.unloadPlaceCountry}`;
          values.clientName = `${response?.data?.data?.name}`;
          values.clientEmail = `${response?.data?.data?.email}`;
          values.removalDate = `${convertDate(response?.data?.data?.loadDate)}`;
          values.refNo = {
            refPart1: `${response?.data?.data?.id}`,
            refPart2: '',
          };

          setFormContent(values);
        }
        setMediaKeysToSend([]);
        setMediaKeysToRemove([]);
      })
      .catch((error) => {
        if (error?.response?.data?.statusCode === 401) {
          localStorage.clear();
          window.location.pathname = '/login';
        }
        setMediaKeysToSend([]);
        setMediaKeysToRemove([]);
      });
  };

  //
  const completeInfo = () => {
    setIsLoading(true);
    markAsComplete(surveyId)
      .then((res) => {
        console.log(res);
        setIsLoading(false);
        setInfo('completed');
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };

  //
  const addContent = () => {
    setIsLoading(true);
    const body = {
      formId: 'a72bee18-cfd0-4ffc-971c-198b5e5b6a63',
      surveyId: surveyId,
      content: formContent,
      mediaKeys: mediaKeysToSend,
      removedMediaKeys: mediaKeysToRemove,
    };
    addFormContent(body)
      .then(() => {
        setSnackbarMessage('Move Checklist has been added successfully!');
        setOpenSnackbar(true);
        setIsEdit(false);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = '/login';
        }

        setIsLoading(false);
      });
  };

  //
  const updateContent = () => {
    setIsLoading(true);

    const body = {
      formId: 'a72bee18-cfd0-4ffc-971c-198b5e5b6a63',
      surveyId: surveyId,
      content: formContent,
      mediaKeys: mediaKeysToSend,
      removedMediaKeys: mediaKeysToRemove,
    };
    updateFormContent(body, formContentId)
      .then((res) => {
        setSnackbarMessage('Move Checklist has been updated successfully!');
        setOpenSnackbar(true);
        getContent();
        setIsEdit(false);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode === 401) {
          localStorage.clear();
          window.location.pathname = '/login';
        }

        setIsLoading(false);
      });
  };

  //
  const getContent = () => {
    setIsLoading(true);
    getFormContent('a72bee18-cfd0-4ffc-971c-198b5e5b6a63', surveyId)
      .then((res) => {
        setFormContentId(res.data.data.uuid);
        setFormContent(res.data.data.content);

        setIsLoading(false);
        setMediaKeysToSend([]);
        setMediaKeysToRemove([]);

        let values = [];
        res.data.data.content.otherDocuments.map((dc, ind) => {
          values[ind] = {
            src: Bucket + dc,
          };
        });

        setSlides(values);
      })
      .catch((error) => {
        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = '/login';
        }

        setIsLoading(false);
        setMediaKeysToSend([]);
        setMediaKeysToRemove([]);
        getSurvey();
      });
  };

  useEffect(() => {
    getContent();
  }, []);

  //
  const uploadOtherFiles = async (event, name) => {
    event.preventDefault();

    // Check if files are selected
    if (event.target.files.length === 0) {
      console.error('No files selected');
      return;
    }

    // Create an array to hold the promises for each file upload
    const uploadPromises = [];
    handleOpen();

    // Loop through each selected file
    for (let i = 0; i < event.target.files.length; i++) {
      const file = event.target.files[i];

      // Create a FormData object and append the current file
      const fd = new FormData();
      fd.append('image', file);

      // Add the file upload promise to the array
      uploadPromises.push(imageUpload(fd));
    }

    try {
      // Wait for all file uploads to complete
      const responses = await Promise.all(uploadPromises);

      // Handle responses
      let values = { ...formContent };
      let md = [...mediaKeysToSend];

      responses.forEach((res) => {
        if (values[name] && Array.isArray(values[name])) {
          values[name].push(res?.data?.data?.key);
          md.push(res?.data?.data?.key);
        }
      });

      setFormContent(values);
      setMediaKeysToSend(md);
      handleClose();
    } catch (error) {
      // Example error handling (you may adjust this part)
      setSnackbarMessage(error?.response?.data?.message);
      setOpenSnackbar(true);

      if (error?.response?.data?.statusCode === 401) {
        localStorage.clear();
        window.location.pathname = '/login';
      }
      handleClose();
    } finally {
      // Optionally, perform any cleanup or additional actions
      setIsLoading(false);
      handleClose();
    }
  };

  const truncateFileName = (name, length) => {
    if (name.length <= length) return name;

    const parts = name.split('.');
    const extension = parts.length > 1 ? '.' + parts.pop() : '';
    const truncatedName =
      parts.join('.').slice(0, length - 3 - extension.length) + '...';

    return truncatedName + extension;
  };

  return (
    <>
      <MainTemplate>
        <Box sx={{ pb: 8 }}>
            <div className="page-header-container d-flex align-items-center mb-5 mt-4">
                <div className="d-flex align-items-center">
                    <div 
                        className="back-bg cursor-pointer me-3" 
                        onClick={() => navigate(-1)} 
                        style={{ 
                            background: 'rgba(15, 23, 42, 0.05)', 
                            padding: '10px', 
                            borderRadius: '12px',
                            transition: 'all 0.2s'
                        }}
                    >
                        <img src={backArrow} height="20" width="20" alt="Back" />
                    </div>
                    <div>
                        <Typography variant="h1" className="gradient-title" sx={{ fontSize: '2rem !important', mb: 0 }}>
                            Move Checklist
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'var(--gray-500)', fontWeight: 500 }}>
                            Manage documents, logistics, and completion status for this shipment
                        </Typography>
                    </div>
                </div>
                <div className="d-flex ms-auto gap-2">
                    {!isEdit ? (
                        <Button
                            variant="outlined"
                            startIcon={<EditIcon />}
                            onClick={() => setIsEdit(true)}
                            sx={{ borderRadius: "10px", textTransform: "none", fontWeight: 700, px: 3 }}
                        >
                            Edit Case
                        </Button>
                    ) : (
                        <>
                            <Button
                                variant="outlined"
                                color="error"
                                startIcon={<CancelIcon />}
                                onClick={() => {
                                    getContent();
                                    setTimeout(() => setIsEdit(false), 300);
                                }}
                                sx={{ borderRadius: "10px", textTransform: "none", fontWeight: 700, px: 3 }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                startIcon={<SaveIcon />}
                                onClick={() => formContentId === '' ? addContent() : updateContent()}
                                disabled={isLoading}
                                sx={{ 
                                    borderRadius: "10px", 
                                    textTransform: "none", 
                                    fontWeight: 700, 
                                    px: 4,
                                    background: "var(--primary-color)",
                                    '&:hover': { background: "var(--primary-hover)" }
                                }}
                            >
                                {isLoading ? "Saving..." : "Save Changes"}
                            </Button>
                        </>
                    )}
                    
                    {infod === 'incomplete' && (
                        <Button
                            variant="contained"
                            startIcon={<CheckCircleIcon />}
                            onClick={completeInfo}
                            disabled={isLoading}
                            sx={{ 
                                borderRadius: "10px", 
                                textTransform: "none", 
                                fontWeight: 700, 
                                px: 3,
                                background: "var(--success-green, #10b981)",
                                '&:hover': { background: "#059669" }
                            }}
                        >
                            Mark as Complete
                        </Button>
                    )}
                </div>
            </div>


        {/*  Details */}
        <SectionHeader title="Move Logistics Details" icon={<LocalShippingIcon />} />
        <PremiumCard sx={{ marginBottom: "40px", p: 4 }}>
             <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                      <Grid container spacing={2}>
                          <Grid item xs={12}>
                            {isEdit ? (
                                <Box sx={{ mb: 2 }}>
                                    <label className="premium-label">Reference Number</label>
                                    <div className="d-flex align-items-center gap-2">
                                        <div 
                                            className="px-3 py-2" 
                                            style={{ 
                                                background: '#f8fafc', 
                                                border: '1px solid #e2e8f0', 
                                                borderRadius: '8px',
                                                fontWeight: 600,
                                                color: '#64748b'
                                            }}
                                        >
                                            {formContent?.refNo?.refPart1}
                                        </div>
                                        <input
                                            type="text"
                                            className="date-field"
                                            style={{ 
                                                flex: 1, 
                                                background: 'white', 
                                                border: '1px solid #e2e8f0', 
                                                padding: '8px 16px', 
                                                borderRadius: '8px' 
                                            }}
                                            value={formContent?.refNo?.refPart2}
                                            onChange={(e) => {
                                                let values = { ...formContent };
                                                values.refNo.refPart2 = e.target.value;
                                                setFormContent(values);
                                            }}
                                            placeholder="Suffix / Ref Part 2"
                                        />
                                    </div>
                                </Box>
                            ) : (
                                <ContactDetailField
                                    label="File Reference"
                                    value={`${formContent?.refNo?.refPart1}${formContent?.refNo?.refPart2}`}
                                    isEdit={false}
                                    minWidth={'140px'}
                                />
                            )}
                          </Grid>
                          <Grid item xs={12}>
                            <ContactDetailField
                                label="Customer Name"
                                value={formContent?.clientName || ''}
                                isEdit={isEdit}
                                type="text"
                                minWidth={'140px'}
                                onChange={(e) => setFormContent({ ...formContent, clientName: e.target.value })}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <ContactDetailField
                                label="Origin Location"
                                value={formContent?.originAddress || ''}
                                isEdit={isEdit}
                                type="text"
                                minWidth={'140px'}
                                onChange={(e) => setFormContent({ ...formContent, originAddress: e.target.value })}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <ContactDetailField
                                label="Destination"
                                value={formContent?.destinationAddress || ''}
                                isEdit={isEdit}
                                type="text"
                                minWidth={'140px'}
                                onChange={(e) => setFormContent({ ...formContent, destinationAddress: e.target.value })}
                            />
                          </Grid>
                      </Grid>
                  </Grid>

                  <Grid item xs={12} md={6}>
                      <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <ContactDetailField
                                label="Organization"
                                value={formContent?.arrangedBy || ''}
                                isEdit={isEdit}
                                type="text"
                                onChange={(e) => setFormContent({ ...formContent, arrangedBy: e.target.value })}
                                minWidth={'140px'}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <ContactDetailField
                                label="Removal Date"
                                value={formContent?.removalDate || ''}
                                isEdit={isEdit}
                                type="date"
                                onChange={(e) => setFormContent({ ...formContent, removalDate: e.target.value })}
                                minWidth={'140px'}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <ContactDetailField
                                label="Shipment Mode"
                                options={[
                                    { value: 'Sea Import', label: 'Sea Import' },
                                    { value: 'Sea Export', label: 'Sea Export' },
                                    { value: 'Air import', label: 'Air import' },
                                    { value: 'Air Export', label: 'Air Export' },
                                    { value: 'Local Shipment', label: 'Local Shipment' },
                                ]}
                                value={formContent?.shipmentMode || ''}
                                isEdit={isEdit}
                                type="select"
                                minWidth={'140px'}
                                onChange={(e) => setFormContent({ ...formContent, shipmentMode: e })}
                            />
                          </Grid>
                          <Grid item xs={6}>
                             <ContactDetailField
                                label="Created"
                                value={formContent?.createdDate || ''}
                                isEdit={isEdit}
                                type="date"
                                onChange={(e) => setFormContent({ ...formContent, createdDate: e.target.value })}
                                minWidth={'80px'}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <ContactDetailField
                                label="Closing"
                                value={formContent?.closingDate || ''}
                                isEdit={isEdit}
                                type="date"
                                onChange={(e) => setFormContent({ ...formContent, closingDate: e.target.value })}
                                minWidth={'80px'}
                            />
                          </Grid>
                      </Grid>
                  </Grid>
             </Grid>
        </PremiumCard>
        {/* / Details */}

        {/* checkboxes */}
        <SectionHeader title="Document Tracking" icon={<ChecklistIcon />} />
        <PremiumCard sx={{ marginBottom: "40px", pb: 2 }}>
            <Typography variant="body2" sx={{ mb: 4, color: 'var(--gray-500)', fontWeight: 600 }}>
                Track completion status of required forms and internal surveyor documents
            </Typography>
            
            <Grid container spacing={2}>
                {/* Core Surveyor Check */}
                <Grid item xs={12} sm={6} md={3}>
                    <Box className="hover-checklist">
                        <CustomCheckbox
                            id="submittedBySurveyor"
                            label="Submitted By Surveyor"
                            value={surveyData?.status === 'submitted' || formContent?.status === 'submitted'}
                            path={`/survey/${surveyId}`}
                            disabled={isEdit}
                        />
                    </Box>
                </Grid>

                {/* Form Checklist */}
                {filesList?.map((file) => {
                    const isRestricted = ["Quotation Form", "Invoice"].includes(file.name);
                    const handleClick = (e) => {
                        if(isRestricted && !isAdmin) {
                            e.preventDefault();
                            setSnackbarMessage("Restricted: Only super admin can access this document");
                            setOpenSnackbar(true);
                        }
                    }

                    return (
                        <Grid item xs={12} sm={6} md={3} key={file.id}>
                            <Box onClickCapture={handleClick} className="hover-checklist">
                                <CustomCheckbox
                                    id={file?.value}
                                    label={file?.name}
                                    value={!!file?.isAdded}
                                    path={
                                        (isRestricted && !isAdmin) ? "#" : 
                                        file?.isAdded === true
                                            ? `/${file.value}/2/${surveyId}/${file.id}/${formContent.arrangedBy || '_'}`
                                            : `/${file.value}/1/${surveyId}/${file.id}/${formContent.arrangedBy || '_'}`
                                    }
                                    disabled={
                                        isEdit || 
                                        (file?.value === 'survey/item-condition-report-at-origin' && formContent?.status !== 'submitted')
                                    }
                                />
                            </Box>
                        </Grid>
                    );
                })}
            </Grid>
        </PremiumCard>

            {/* Upload Documents Section */}
            <SectionHeader title="Supporting Documents & Media" icon={<CloudUploadIcon />} />
            <PremiumCard sx={{ marginBottom: "40px", p: 4 }}>
                <Typography variant="body2" sx={{ mb: 4, color: 'var(--gray-500)', fontWeight: 600 }}>
                    Upload and manage additional shipment documents, waybills, and bills of lading
                </Typography>

                <Grid container spacing={4}>
                    {[
                        { label: 'Waybill (Origin)', field: 'wayBillOfOriginAgent', uploadId: 'originUpload' },
                        { label: 'Waybill (Booker)', field: 'wayBillOfBooker', uploadId: 'bookerUpload' },
                        { label: 'Bill of Lading', field: 'oceanBillOfLoading', uploadId: 'oceanUpload' },
                        { label: 'Air Way Bill', field: 'airWayBill', uploadId: 'airUpload' },
                        { label: 'Other Documents', field: 'otherDocuments', uploadId: 'otherUpload' },
                    ].map((doc) => (
                        <Grid item xs={12} sm={6} md={4} key={doc.field}>
                            <Box sx={{ 
                                p: 2, 
                                borderRadius: '12px', 
                                border: '1px solid #e2e8f0',
                                background: 'rgba(248, 250, 252, 0.5)',
                                height: '100%',
                                transition: 'all 0.2s',
                                '&:hover': { background: '#f8fafc', borderColor: 'var(--primary-color)' }
                            }}>
                                <div className="d-flex align-items-center justify-content-between mb-2">
                                    <div className="d-flex align-items-center gap-2">
                                        <AssignmentIcon sx={{ color: 'var(--primary-600)', fontSize: 20 }} />
                                        <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'var(--text-main)' }}>
                                            {doc.label}
                                        </Typography>
                                    </div>
                                    {isEdit && (
                                        <>
                                            <input
                                                type="file"
                                                hidden
                                                id={doc.uploadId}
                                                onChange={(e) => uploadOtherFiles(e, doc.field)}
                                                multiple
                                            />
                                            <Tooltip title="Upload Files">
                                                <label htmlFor={doc.uploadId}>
                                                    <CloudUploadIcon sx={{ color: 'var(--primary-color)', cursor: 'pointer', fontSize: 22 }} />
                                                </label>
                                            </Tooltip>
                                        </>
                                    )}
                                </div>

                                <Box sx={{ mt: 1 }}>
                                    {formContent[doc.field] && formContent[doc.field].length > 0 ? (
                                        formContent[doc.field].map((oth, ind) => (
                                            <div key={oth} className="d-flex align-items-center justify-content-between py-1 px-2 mb-1" style={{ background: 'white', borderRadius: '6px', border: '1px solid #f1f5f9' }}>
                                                <Typography 
                                                    variant="caption" 
                                                    className="cursor-pointer"
                                                    onClick={() => {
                                                        const values = formContent[doc.field].map(ot => ({ src: Bucket + ot }));
                                                        setSlides(values);
                                                        setIndex(ind);
                                                    }}
                                                    sx={{ 
                                                        color: 'var(--primary-600)', 
                                                        fontWeight: 600,
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        maxWidth: '160px'
                                                    }}
                                                >
                                                    {ind + 1}. {truncateFileName(oth, 24)}
                                                </Typography>
                                                <div className="d-flex gap-1">
                                                    <a href={Bucket + oth} target="_blank" rel="noreferrer">
                                                        <DownloadIcon sx={{ fontSize: 16, color: 'var(--gray-500)' }} />
                                                    </a>
                                                    {isEdit && (
                                                        <DeleteOutlineIcon 
                                                            sx={{ fontSize: 16, color: 'var(--red-500)', cursor: 'pointer' }}
                                                            onClick={() => {
                                                                const values = { ...formContent };
                                                                values[doc.field].splice(ind, 1);
                                                                setFormContent(values);
                                                                setMediaKeysToRemove([...mediaKeysToRemove, oth]);
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <Typography variant="caption" sx={{ color: 'var(--gray-400)', fontStyle: 'italic' }}>
                                            No documents attached
                                        </Typography>
                                    )}
                                </Box>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </PremiumCard>
        {/* /checkboxes*/}

        {/* Remarks */}
        <SectionHeader title="Operational Remarks" icon={<AssignmentIcon />} />
        <PremiumCard sx={{ marginBottom: "40px", p: 4 }}>
          <DynamicText
            label="Internal Remarks (If Any):"
            value={formContent?.remarks}
            isEdit={isEdit}
            onChange={(e) => {
              let values = { ...formContent };
              values.remarks = e.target.value;
              setFormContent(values);
            }}
          />
        </PremiumCard>
        {/* /Remarks */}
        <Snackbar
          className="no-print"
          open={openSnackbar}
          autoHideDuration={6000} // Adjust the duration as needed
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            severity={
              snackbarMessage?.includes('successful') ? 'success' : 'error'
            }
            onClose={handleCloseSnackbar}
          >
            {snackbarMessage}
          </MuiAlert>
        </Snackbar>
        </Box>
      </MainTemplate>

      <LoadingModal open={open} handleClose={handleClose} />

      <Lightbox
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
        slides={slides}
        carousel={{ finite: slides.length <= 1 }}
        render={{
          buttonPrev: slides.length <= 1 ? () => null : undefined,
          buttonNext: slides.length <= 1 ? () => null : undefined,
        }}
      />
    </>
  );
};
export default MoveCheckList;
